/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

/*
 * Bridges the Appstle Subscriptions widget (an app block rendered outside the
 * product <form>) with the theme's add-to-cart and dynamic checkout buttons.
 *
 * It mirrors the selected selling_plan into a hidden <input name="selling_plan">
 * inside every add-to-cart form of the product section, so both the theme's
 * custom AJAX add-to-cart and the native payment button carry the subscription.
 *
 * Does nothing when no Appstle widget is present (no hidden input added), and
 * removes the input for a one-time purchase, so non-subscription products and
 * one-time selections keep their normal behavior.
 */
(function () {
  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  const HIDDEN_CLASS = 'js-appstle-selling-plan';

  function getSelectedPlan(scope) {
    const checked = scope.querySelector('input[name="selling_plan"]:checked');
    if (!checked || !checked.value) return '';
    const frequency = scope.querySelector('select.appstle_select');
    return (frequency && frequency.value) || checked.value;
  }

  function sync(scope) {
    const value = getSelectedPlan(scope);

    scope.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      let input = form.querySelector('input.' + HIDDEN_CLASS);

      if (!value) {
        if (input) input.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.className = HIDDEN_CLASS;
        form.appendChild(input);
      }
      input.value = value;
    });
  }

  function scopeOf(el) {
    return el.closest('[id^="shopify-section"]') || document;
  }

  // Coalesce bursts of widget mutations (price/money re-renders) into one sync.
  function rafDebounce(fn) {
    let scheduled = false;
    return function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        fn();
      });
    };
  }

  // User selection: a single delegated listener, syncs immediately and survives
  // Appstle re-renders.
  document.addEventListener('change', function (event) {
    const target = event.target;
    if (target.matches?.('input[name="selling_plan"], select.appstle_select')) {
      sync(scopeOf(target));
    }
  });

  function observeWidget(widget) {
    if (widget.dataset.sellingPlanObserved) return;
    widget.dataset.sellingPlanObserved = 'true';

    const scope = scopeOf(widget);
    sync(scope);

    // Catches programmatic selection changes (default plan, morph re-render).
    new MutationObserver(rafDebounce(function () {
      sync(scope);
    })).observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'data-selected-selling-plan'],
    });
  }

  function init() {
    document.querySelectorAll('.appstle_sub_widget').forEach(observeWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
